<template>
    <div id="app">
        <div class="layout"
             v-if="!textNull">
            <!-- 这里适配了教师问卷移动端的样式el-container-mobile -->
            <el-container class="is-vertical"
                          :class="show || !isMobile?'el-container-all':'el-container-mobile'">
                <el-header height="64px"
                           v-if="show">
                    <set-header :loginInfo="loginInfo"></set-header>
                </el-header>
                <!-- iframe放在router-view下面否则会重新加载 -->
                <!-- 监控分析 params.userCode监听userCode是否取到值-->
                <!-- <div class="iframeTyle"
                     v-show="PDAnalyze && pathIndex && !PDresource"
                     v-if="commonality.identity">
                    <iframe class="supervising"
                            name="supervising"
                            id="supervising"
                            v-if="turnJudge && PDAnalyze"
                            :src="supervisingUrl"></iframe>
                </div> -->
                <div class="iframeTyle"
                     v-show="!PDAnalyze && pathIndex && PDresource"
                     v-if="commonality.identity">
                    <iframe class="resource"
                            name="resource"
                            id="resource"
                            v-if="turnJudge && PDresource"
                            :src="resourceUrl"></iframe>
                </div>
                <!-- 内容区 -->
                <el-scrollbar wrap-class="default-scrollbar__wrap"
                              view-class="default-scrollbar__view"
                              class="default-scrollbar appscrollbar"
                              v-SetScrollbar="scrollbarOrder"
                              v-show="pathIndex && !PDresource"
                              :style="{ height: computHei }">
                    <keep-alive>
                        <router-view v-if="$route.meta.keepAlive"></router-view>
                    </keep-alive>
                    <router-view v-if="!$route.meta.keepAlive"></router-view>
                </el-scrollbar>
                <el-footer class="footer"
                           v-if="$address && examineHeaderPd && show && VXcommon.pathName && (VXcommon.pathName.headerWidth) && pathIndex"
                           v-html="$address"></el-footer>
                <!-- 加载提示 -->
                <noContent :count="pathIndex"
                           :styleIndex="1"></noContent>
            </el-container>
        </div>
        <!--提示 -->
        <auto-quit-tips :message="message"
                        :top.sync='top'
                        ref="autoQuitTips">
        </auto-quit-tips>
        <!-- 网络异常    -->
        <errorNull :textNull="textNull"
                   v-if="textNull"></errorNull>
    </div>
</template>
<script>
import { adoptdevice, defaultFontSize } from '@/common/js/util'
import { commonality } from '@/util/commonality'
import SetHeader from 'components/header/header'
import noContent from 'base/no-content'
import { loginInfo } from 'common/js/util.js'
import { mapGetters } from 'vuex'
import Vue from 'vue'
export default {
    components: { SetHeader, noContent },
    mixins: [commonality],
    data () {
        return {
            map: {},
            defaultFontSize: '',
            turnJudge: ''
        }
    },
    // provide () {
    //   return {
    //     appEv: this,
    //     a: this.a
    //   }
    // },
    created () {
        this.defaultFontSize = defaultFontSize()
        adoptdevice(1920, 100, this.defaultFontSize)
        // this.$listen('resize', this.adopt, 'add', 'init')
        window.addEventListener('resize', () => {
            setTimeout(() => {
                adoptdevice(1920, 100, this.defaultFontSize)
            }, 200)
        })
        if (sessionStorage.getItem('loginInfo')) {
            let obj = JSON.parse(sessionStorage.getItem('loginInfo'))
            obj.universityId = window.config.universityId
            sessionStorage.setItem('loginInfo', JSON.stringify(obj))
            this.getConfig()
        }
    },
    methods: {
        adopt () {
            adoptdevice(1920, 100, this.defaultFontSize)
        },
        getConfig () {
            let url2 = `/sensitiveConfig`
            Vue.prototype.$http.get(url2, { noAuth: true, keys: "resourceUrl,resourceUrl,supervisingUrl,fileViewUrl1,fileViewUrl2,urlFileUploading,JumpAdressList,JumpAdressEvaluate,urlFile", }).then((config) => {
                Vue.prototype.$urlFile = config.content.urlFile
                Vue.prototype.$resourceUrl = config.content.resourceUrl; //资源地址
                Vue.prototype.$supervisingUrl = config.content.supervisingUrl; //教学质量监控分析地址
                Vue.prototype.$fileViewUrl1 = config.content.fileViewUrl1; //图片查看地址1
                Vue.prototype.$fileViewUrl2 = config.content.fileViewUrl2; //图片查看地址2
                Vue.prototype.$urlUploading = `${config.content.urlFileUploading}/fileUpload`;//图片上传地址
                Vue.prototype.$urlFileUploading = `${config.content.urlFileUploading}/fileUpload`;//文件上传地址
                Vue.prototype.$JumpAdressList = config.content.JumpAdressList;
                Vue.prototype.$JumpAdressEvaluate = config.content.JumpAdressEvaluate;
            })
        },
    },
    computed: {
        ...mapGetters([
            'commonality' // 路由  数据接口
        ]),
        params () {
            var param = loginInfo()
            return {
                userCode: param.userCode,
                operatorId: param.operatorId,
                universityId: param.universityId
            }
        },

        supervisingUrl () { // 分析
            // &userName传但用不到 资源需要这里有sessionStorage 问题
            let time = new Date().getTime()
            return `${this.$supervisingUrl}/#/analysisPoint?operatorId=${loginInfo().userCode}&universityId=${this.$universityId}&userCode=${loginInfo().userCode}&token=${loginInfo().token}&userName=${this.commonality.atUserInfo.userName}&time=${time}`
        },
        resourceUrl () { // 资源
            let time = new Date().getTime()
            let str = encodeURIComponent(`operatorId=${loginInfo().userCode}&universityId=${this.$universityId}&userCode=${loginInfo().userCode}&userName=${this.commonality.atUserInfo.userName}&token=${loginInfo().token}&name=我的校级资源&orgName=${this.commonality.atUserInfo.orgName}&time=${time}`)
            return `${this.$resourceUrl}/#/resource-management-layout/all-file?authRes=init&data=${str}`
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                //  iframe 避免重复刷新
                if (from && (from.path === '/supervising' || from.path === '/resource')) {
                    this.turnJudge = false
                }
                if (!this.turnJudge) {
                    setTimeout(() => {
                        if (!this.turnJudge) this.turnJudge = true
                    }, 1000)
                }
                // 判断浏览器前进方向 去除异常状态
                if (from) {
                    if (!this.map[to.path]) {
                        this.map[to.path] = +new Date() + 1
                    }
                    if (!this.map[from.path]) {
                        this.map[from.path] = +new Date()
                    }
                    if (!this.map[to.path] > this.map[from.path]) {
                        if (this.textNull) this.textNull = ''
                    }
                }
            },
            immediate: true
        }

    }
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import 'common/stylus/index'
#app {
    width: 100%
    height: 100%
    font-family: 'Microsoft YaHei', 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', '微软雅黑', Arial
    .layout {
        width: 100%
        height: 100%
        overflow: auto
        section >.el-footer {
            height: 0.64rem !important
            max-height: 64px
            background: #fff !important
            border-top: 1px solid #D4D4D4
            display: flex
            align-items: center
            justify-content: center
            font-size: 14px
            color: #909BA8
        }
        .appscrollbar {
            background-color: #e6eaed
            >.el-scrollbar__wrap.default-scrollbar__wrap {
                overflow-y: auto
            }
        }
        .el-container-all {
            height: 100%
            min-width: 1200px
            >div:not(section) {
                // 这里的样式影响到了内部使用，按理el-scrollbar是带了内部滚动的，不需要外出设置滚动属性，所以这里设置了禁止滚动
                // overflow-y: auto
                // overflow-x: hidden
                position: relative
                overflow: hidden
            }
            >.el-header {
                background-color: #0D81E0
            }
        }
        .el-container-mobile {
            width: 100%
            height: 100%
        }
    }
    .iframeTyle {
        height: calc(100% - 124px)
        overflow-y: hidden !important
        .resource {
            height: 100%
            min-width: 100px
            min-height: 800px
            width: 100%
            overflow: auto
        }
        .supervising {
            height: 100%
            min-width: 100px
            // min-height: 800px
            width: 100%
            overflow: auto
        }
    }
    .el-table {
        tr:nth-child(2n) {
            background-color: #F7FCFC
        }
    }
}
@media (max-width: 768px) {
    /* 适应手机屏幕的样式 */
    body {
        font-size: 16px /* 调整字体大小以避免缩放 */
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue